import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

export const useSwipeNavigation = () => {
  const navigate = useNavigate();
  const touchStartX = useRef<number>(0);
  const touchEndX = useRef<number>(0);

  useEffect(() => {
    const handleTouchStart = (e: TouchEvent) => {
      touchStartX.current = e.touches[0].clientX;
    };

    const handleTouchEnd = (e: TouchEvent) => {
      // Check if touch originated from carousel or modal - don't navigate
      const target = e.target as HTMLElement;
      const isCarousel = target.closest('[role="region"][aria-label*="carousel"]');
      const isModal = target.closest('[data-image-modal]');
      
      if (isCarousel || isModal) {
        return;
      }

      touchEndX.current = e.changedTouches[0].clientX;
      const swipeDistance = touchEndX.current - touchStartX.current;
      
      // Swipe right (back gesture) - minimum 100px
      if (swipeDistance > 100) {
        navigate(-1);
      }
    };

    document.addEventListener('touchstart', handleTouchStart);
    document.addEventListener('touchend', handleTouchEnd);

    return () => {
      document.removeEventListener('touchstart', handleTouchStart);
      document.removeEventListener('touchend', handleTouchEnd);
    };
  }, [navigate]);
};
